var Backbone = require('backbone')
  , Overlay = require('mobile/ui/Overlay')
  , enableDialog = require('mobile/ui/enableDialog')

var AlertView = Backbone.View.extend({
  initialize: function(options) {
    this.content = options.content
    this.html = options.html
  }
, render: function() {
    var formContent = $('<div>', { 'class': 'form' })

    formContent.append(
      this.content
      ? $('<div>', { 'class': 'form-result'}).html(
          $('<p>').text(this.content)
        )
      : this.html
    )

    formContent.append(
      $('<div>', { 'class' : 'form-opera' }).html(
        $('<button>', { 'class': 'form-bt-submit btn-overlay-close' }).text('我知道了')
      )
    )

    this.$el.html(formContent)

    return this
  }
})

module.exports = function(options) {
  options = options || {}

  var View = enableDialog(AlertView)
    , alertView = new View(options)

  return alertView.render().open()
}
